import React from 'react';

import { translate } from '@vestahealthcare/common/i18n';
import { Address } from '@vestahealthcare/common/models';
import { EMPTY } from '@vestahealthcare/common/utils/constants';

type Props = {
  address?: Address;
};

export const MemberAddressDetail = ({ address }: Props) =>
  !address || address?.isEmpty ? (
    <>{EMPTY}</>
  ) : (
    <>
      {address.address1 && <p className="no-margin">{address.address1}</p>}
      {address.address2 && <p className="no-margin">{address.address2}</p>}
      <p className="no-margin">{address.formattedAddress.city || EMPTY}</p>
      <p className="no-margin">
        <a
          href={address.googleMapsLink}
          target="_blank"
          rel="noopener noreferrer"
          className="small"
        >
          ({translate('personalDetails.personalDetailsCard.viewOnMap')})
        </a>
      </p>
    </>
  );
